(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lc-gift-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-lcg-open-chat]') : null;
    if (!trigger || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const chat = document.querySelector('shopify-chat');
    if (chat?.hasAttribute('open')) {
      event.preventDefault();
      return;
    }
    const activator = chat?.shadowRoot?.querySelector('button[part="activator"]');
    if (!activator) return;
    event.preventDefault();
    if (activator.getAttribute('aria-expanded') !== 'true') activator.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-gourmandises-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lc-related-carousel')) {
    customElements.define('lc-related-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.lc-related__track');
        this.controls = this.querySelector('.lc-related__controls');
        if (!this.track || !this.controls) return;
        this.cards = Array.from(this.track.children);
        this.previous = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.position = this.querySelector('[data-position]');
        this.index = 0;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.controls.addEventListener('click', event => {
          const button = event.target.closest('[data-direction]');
          if (!button || button.disabled) return;
          const index = Math.max(0, Math.min(this.cards.length - 1, this.index + Number(button.dataset.direction)));
          const left = this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft - parseFloat(getComputedStyle(this.track).paddingLeft);
          this.track.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }, {signal});
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, {passive: true, signal});
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const mobile = matchMedia('(max-width: 749px)').matches;
        this.controls.hidden = !mobile || this.cards.length < 2 || max < 2;
        const left = Math.max(0, this.track.scrollLeft);
        const step = this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        this.index = max > 2 && left >= max - 2 ? this.cards.length - 1 : Math.min(this.cards.length - 1, Math.round(left / step));
        this.previous.disabled = left <= 2;
        this.next.disabled = left >= max - 2;
        const current = String(this.index + 1);
        const total = String(this.cards.length);
        const visible = current + ' / ' + total;
        if (this.position.querySelector('[data-position-visible]').textContent !== visible) {
          this.position.querySelector('[data-position-visible]').textContent = visible;
          this.position.querySelector('[data-position-label]').textContent = this.position.dataset.positionTemplate.replace('[current]', current).replace('[total]', total);
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-jardin-wearing-formats"]) return;
  try {
    
  if (!customElements.get('lc-jardin-wearing')) {
    customElements.define('lc-jardin-wearing', class extends HTMLElement {
      connectedCallback() {
        if (this._track) return;
        this._track = this.querySelector('.lc-jardin-wearing__track');
        this._cards = Array.from(this.querySelectorAll('.lc-jardin-wearing__card'));
        this._previous = this.querySelector('[data-wearing-previous]');
        this._next = this.querySelector('[data-wearing-next]');
        this._page = this.querySelector('[data-wearing-page]');
        this._index = 0;
        this._frame = null;
        this._update = () => {
          const origin = this._cards[0].offsetLeft;
          this._index = this._cards.reduce((closest, card, index) => Math.abs(card.offsetLeft - origin - this._track.scrollLeft) < Math.abs(this._cards[closest].offsetLeft - origin - this._track.scrollLeft) ? index : closest, 0);
          this._previous.disabled = this._index === 0;
          this._next.disabled = this._index === this._cards.length - 1;
          this._page.textContent = (this._index + 1) + ' / ' + this._cards.length;
        };
        this._go = (direction) => {
          const index = Math.max(0, Math.min(this._cards.length - 1, this._index + direction));
          const left = this._cards[index].offsetLeft - this._cards[0].offsetLeft;
          this._track.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this._onPrevious = () => this._go(-1);
        this._onNext = () => this._go(1);
        this._onScroll = () => {
          if (this._frame !== null) return;
          this._frame = requestAnimationFrame(() => { this._frame = null; this._update(); });
        };
        this._onKey = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          if (!window.matchMedia('(max-width: 749px)').matches) return;
          event.preventDefault();
          this._go(event.key === 'ArrowRight' ? 1 : -1);
        };
        this._previous.addEventListener('click', this._onPrevious);
        this._next.addEventListener('click', this._onNext);
        this._track.addEventListener('scroll', this._onScroll, { passive: true });
        this._track.addEventListener('keydown', this._onKey);
        this._resizeObserver = new ResizeObserver(this._update);
        this._resizeObserver.observe(this._track);
        this._update();
      }
      disconnectedCallback() {
        this._previous?.removeEventListener('click', this._onPrevious);
        this._next?.removeEventListener('click', this._onNext);
        this._track?.removeEventListener('scroll', this._onScroll);
        this._track?.removeEventListener('keydown', this._onKey);
        this._resizeObserver?.disconnect();
        if (this._frame !== null) cancelAnimationFrame(this._frame);
        this._track = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-parisiennes-wearing"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(section) {
    const rail = section.querySelector('.lc-parisiennes-wearing__rail');
    if (!rail || rail.dataset.lcWearingReady) return;
    rail.dataset.lcWearingReady = 'true';
    const cards = [...rail.querySelectorAll('.lc-parisiennes-wearing__card')];
    const status = section.querySelector('.lc-parisiennes-wearing__status');
    const controls = section.querySelector('.lc-parisiennes-wearing__controls');
    const viewport = section.querySelector('.lc-parisiennes-wearing__viewport');
    const previous = section.querySelector('[data-lc-wearing-prev]');
    const next = section.querySelector('[data-lc-wearing-next]');
    if (!cards.length || !previous || !next || !status || !controls || !viewport) return;
    const position = card => card.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft - parseFloat(getComputedStyle(rail).paddingLeft || 0);
    const current = () => cards.reduce((best, card, index) => Math.abs(position(card) - rail.scrollLeft) < Math.abs(position(cards[best]) - rail.scrollLeft) ? index : best, 0);
    const update = () => {
      const index = current();
      status.textContent = controls.dataset.lcSlideLabel.replace('__INDEX__', String(index + 1));
      const image = cards[index].querySelector('img');
      const frame = image.getBoundingClientRect();
      const origin = viewport.getBoundingClientRect();
      const left = Math.max(20, frame.left - origin.left);
      const right = Math.min(viewport.clientWidth - 20, frame.right - origin.left);
      controls.style.left = (left + 8) + 'px';
      controls.style.right = (viewport.clientWidth - right + 8) + 'px';
      controls.style.top = (frame.top - origin.top + frame.height / 2 - 22) + 'px';
      controls.classList.add('is-ready');
      previous.disabled = index === 0;
      next.disabled = index === cards.length - 1;
    };
    function move(direction) {
      const index = Math.max(0, Math.min(cards.length - 1, current() + direction));
      rail.scrollTo({ left: position(cards[index]), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, { passive: true });
    rail.addEventListener('keydown', event => {
      if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    });
    new ResizeObserver(update).observe(rail);
    update();
  }
  document.querySelectorAll('.lc-parisiennes-wearing').forEach(setup);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches('.lc-parisiennes-wearing')) setup(event.target);
    event.target.querySelectorAll('.lc-parisiennes-wearing').forEach(setup);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-product50-foundation"]) return;
  try {
    
  function initLcProduct50Clearance() {
    if (!document.querySelector('.lc-product50-foundation') || document.body.dataset.lcProduct50Clearance) return;
    document.body.dataset.lcProduct50Clearance = 'true';
    const observedGalleries = new WeakSet();
    const galleryObservers = [];
    let pending = false;
    const check = () => {
      pending = false;
      const nextLabel = document.querySelector('.lc-product50-foundation')?.dataset.nextLabel;
      if (nextLabel) document.querySelectorAll('.t4s-main-product__content .t4s-product__media-wrapper .flickityt4s-prev-next-button.next').forEach(button => {
        if (button.getAttribute('aria-label') !== nextLabel) button.setAttribute('aria-label', nextLabel);
      });
      const previousLabel = document.querySelector('.lc-product50-foundation')?.dataset.previousLabel;
      document.querySelectorAll('.t4s-main-product__content .t4s-product__media-wrapper .t4s-flicky-slider').forEach(gallery => {
        const slides = [...gallery.querySelectorAll('.t4s-product__media-item')].filter(slide => !slide.matches('.t4s-dn,.is--media-hide'));
        const index = slides.findIndex(slide => slide.classList.contains('is-selected'));
        const previous = gallery.querySelector(':scope > .flickityt4s-prev-next-button.previous');
        if (index <= 0 && document.activeElement === previous && matchMedia('(max-width: 749px)').matches) gallery.querySelector(':scope > .flickityt4s-prev-next-button.next')?.focus({ preventScroll: true });
        gallery.classList.toggle('lc-gallery-has-previous', index > 0);
        if (previousLabel && previous?.getAttribute('aria-label') !== previousLabel) previous?.setAttribute('aria-label', previousLabel);
        if (!observedGalleries.has(gallery)) {
          const galleryObserver = new MutationObserver(records => {
            if (records.some(record => record.target.matches('.t4s-product__media-item'))) schedule();
          });
          galleryObserver.observe(gallery, { attributes: true, subtree: true, attributeFilter: ['class'] });
          galleryObservers.push(galleryObserver);
          observedGalleries.add(gallery);
        }
      });
      const activator = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('[part~="activator"]');
      if (!matchMedia('(max-width: 749px)').matches || !activator || activator.getAttribute('aria-expanded') === 'true') {
        document.body.classList.remove('lc-product50-cta-clear');
        return;
      }
      const chat = activator.getBoundingClientRect();
      const overlap = [...document.querySelectorAll('.t4s-product-form__submit,.shopify-payment-button,.t4s-sticky-atc__atc')].some(element => {
        if (!element.checkVisibility()) return false;
        const rect = element.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.left < chat.right && rect.right > chat.left && rect.top < chat.bottom && rect.bottom > chat.top;
      });
      document.body.classList.toggle('lc-product50-cta-clear', overlap);
    };
    const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(check); } };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    document.addEventListener('load', schedule, true);
    document.fonts.ready.then(schedule);
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    const resizeObserver = new ResizeObserver(schedule);
    document.querySelectorAll('.t4s-main-product__content,.t4s-product-form__buttons').forEach(element => resizeObserver.observe(element));
    const readinessTimer = setInterval(() => {
      schedule();
      if (document.querySelector('shopify-chat')?.shadowRoot?.querySelector('[part~="activator"]')) clearInterval(readinessTimer);
    }, 250);
    setTimeout(() => clearInterval(readinessTimer), 15000);
    addEventListener('pagehide', () => { observer.disconnect(); resizeObserver.disconnect(); galleryObservers.forEach(item => item.disconnect()); clearInterval(readinessTimer); }, { once: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLcProduct50Clearance, { once: true });
  else initLcProduct50Clearance();
  document.addEventListener('shopify:section:load', initLcProduct50Clearance);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-product70-foundation"]) return;
  try {
    
  function initLcProduct70Clearance() {
    if (!document.querySelector('.lc-product70-foundation') || document.body.dataset.lcProduct70Clearance) return;
    document.body.dataset.lcProduct70Clearance = 'true';
    const observedGalleries = new WeakSet();
    const galleryObservers = [];
    let pending = false;
    const check = () => {
      pending = false;
      const nextLabel = document.querySelector('.lc-product70-foundation')?.dataset.nextLabel;
      if (nextLabel) document.querySelectorAll('.t4s-main-product__content .t4s-product__media-wrapper .flickityt4s-prev-next-button.next').forEach(button => {
        if (button.getAttribute('aria-label') !== nextLabel) button.setAttribute('aria-label', nextLabel);
      });
      const previousLabel = document.querySelector('.lc-product70-foundation')?.dataset.previousLabel;
      document.querySelectorAll('.t4s-main-product__content .t4s-product__media-wrapper .t4s-flicky-slider').forEach(gallery => {
        const slides = [...gallery.querySelectorAll('.t4s-product__media-item')].filter(slide => !slide.matches('.t4s-dn,.is--media-hide'));
        const index = slides.findIndex(slide => slide.classList.contains('is-selected'));
        const previous = gallery.querySelector(':scope > .flickityt4s-prev-next-button.previous');
        if (index <= 0 && document.activeElement === previous && matchMedia('(max-width: 749px)').matches) gallery.querySelector(':scope > .flickityt4s-prev-next-button.next')?.focus({ preventScroll: true });
        gallery.classList.toggle('lc-gallery-has-previous', index > 0);
        if (previousLabel && previous?.getAttribute('aria-label') !== previousLabel) previous?.setAttribute('aria-label', previousLabel);
        if (!observedGalleries.has(gallery)) {
          const galleryObserver = new MutationObserver(records => {
            if (records.some(record => record.target.matches('.t4s-product__media-item'))) schedule();
          });
          galleryObserver.observe(gallery, { attributes: true, subtree: true, attributeFilter: ['class'] });
          galleryObservers.push(galleryObserver);
          observedGalleries.add(gallery);
        }
      });
      const activator = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('[part~="activator"]');
      if (!matchMedia('(max-width: 749px)').matches || !activator || activator.getAttribute('aria-expanded') === 'true') {
        document.body.classList.remove('lc-product70-cta-clear');
        return;
      }
      const chat = activator.getBoundingClientRect();
      const overlap = [...document.querySelectorAll('.t4s-product-form__submit,.shopify-payment-button,.t4s-sticky-atc__atc')].some(element => {
        if (!element.checkVisibility()) return false;
        const rect = element.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.left < chat.right && rect.right > chat.left && rect.top < chat.bottom && rect.bottom > chat.top;
      });
      document.body.classList.toggle('lc-product70-cta-clear', overlap);
    };
    const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(check); } };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    document.addEventListener('load', schedule, true);
    document.fonts.ready.then(schedule);
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    const resizeObserver = new ResizeObserver(schedule);
    document.querySelectorAll('.t4s-main-product__content,.t4s-product-form__buttons').forEach(element => resizeObserver.observe(element));
    const readinessTimer = setInterval(() => {
      schedule();
      if (document.querySelector('shopify-chat')?.shadowRoot?.querySelector('[part~="activator"]')) clearInterval(readinessTimer);
    }, 250);
    setTimeout(() => clearInterval(readinessTimer), 15000);
    addEventListener('pagehide', () => { observer.disconnect(); resizeObserver.disconnect(); galleryObservers.forEach(item => item.disconnect()); clearInterval(readinessTimer); }, { once: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLcProduct70Clearance, { once: true });
  else initLcProduct70Clearance();
  document.addEventListener('shopify:section:load', initLcProduct70Clearance);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-product90-foundation"]) return;
  try {
    
  function initLcProduct90Clearance() {
    if (!document.querySelector('.lc-product90-foundation') || document.body.dataset.lcProduct90Clearance) return;
    document.body.dataset.lcProduct90Clearance = 'true';
    const observedGalleries = new WeakSet();
    const galleryObservers = [];
    let pending = false;
    const check = () => {
      pending = false;
      const nextLabel = document.querySelector('.lc-product90-foundation')?.dataset.nextLabel;
      if (nextLabel) document.querySelectorAll('.t4s-main-product__content .t4s-product__media-wrapper .flickityt4s-prev-next-button.next').forEach(button => {
        if (button.getAttribute('aria-label') !== nextLabel) button.setAttribute('aria-label', nextLabel);
      });
      const previousLabel = document.querySelector('.lc-product90-foundation')?.dataset.previousLabel;
      document.querySelectorAll('.t4s-main-product__content .t4s-product__media-wrapper .t4s-flicky-slider').forEach(gallery => {
        const slides = [...gallery.querySelectorAll('.t4s-product__media-item')].filter(slide => !slide.matches('.t4s-dn,.is--media-hide'));
        const index = slides.findIndex(slide => slide.classList.contains('is-selected'));
        const previous = gallery.querySelector(':scope > .flickityt4s-prev-next-button.previous');
        if (index <= 0 && document.activeElement === previous && matchMedia('(max-width: 749px)').matches) gallery.querySelector(':scope > .flickityt4s-prev-next-button.next')?.focus({ preventScroll: true });
        gallery.classList.toggle('lc-gallery-has-previous', index > 0);
        if (previousLabel && previous?.getAttribute('aria-label') !== previousLabel) previous?.setAttribute('aria-label', previousLabel);
        if (!observedGalleries.has(gallery)) {
          const galleryObserver = new MutationObserver(records => {
            if (records.some(record => record.target.matches('.t4s-product__media-item'))) schedule();
          });
          galleryObserver.observe(gallery, { attributes: true, subtree: true, attributeFilter: ['class'] });
          galleryObservers.push(galleryObserver);
          observedGalleries.add(gallery);
        }
      });
      const activator = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('[part~="activator"]');
      if (!matchMedia('(max-width: 749px)').matches || !activator || activator.getAttribute('aria-expanded') === 'true') {
        document.body.classList.remove('lc-product90-cta-clear');
        return;
      }
      const chat = activator.getBoundingClientRect();
      const overlap = [...document.querySelectorAll('.t4s-product-form__submit,.shopify-payment-button,.t4s-sticky-atc__atc')].some(element => {
        if (!element.checkVisibility()) return false;
        const rect = element.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.left < chat.right && rect.right > chat.left && rect.top < chat.bottom && rect.bottom > chat.top;
      });
      document.body.classList.toggle('lc-product90-cta-clear', overlap);
    };
    const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(check); } };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    document.addEventListener('load', schedule, true);
    document.fonts.ready.then(schedule);
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    const resizeObserver = new ResizeObserver(schedule);
    document.querySelectorAll('.t4s-main-product__content,.t4s-product-form__buttons').forEach(element => resizeObserver.observe(element));
    const readinessTimer = setInterval(() => {
      schedule();
      if (document.querySelector('shopify-chat')?.shadowRoot?.querySelector('[part~="activator"]')) clearInterval(readinessTimer);
    }, 250);
    setTimeout(() => clearInterval(readinessTimer), 15000);
    addEventListener('pagehide', () => { observer.disconnect(); resizeObserver.disconnect(); galleryObservers.forEach(item => item.disconnect()); clearInterval(readinessTimer); }, { once: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLcProduct90Clearance, { once: true });
  else initLcProduct90Clearance();
  document.addEventListener('shopify:section:load', initLcProduct90Clearance);

  } catch(e) { console.error(e); }
})();
})();
